// no Cognito in Gen 2 (app has no logins)
import React, { useContext, useState, useEffect } from "react";
import { Helmet } from 'react-helmet';
import {
    CartStateContext,
    CartDispatchContext,
    toggleCartPopup
} from "../contexts/cart";
import CartPreview from "./CartPreview";
import {
    Link,
} from 'react-router-dom';
import {
    Image,
    Badge,
    Grid,
    Card,
    View,
    Heading

} from '@aws-amplify/ui-react';


const HeaderNew = (props) => {

    const { items: cartItems } = useContext(CartStateContext);
    const cartDispatch = useContext(CartDispatchContext);


    const handleCartButton = (event) => {
        event.preventDefault();
        return toggleCartPopup(cartDispatch);
    }

    const cartCount = cartItems
        ? cartItems.map((item) => item.quantity).reduce((prev, curr) => prev + curr, 0)
        : 0;

    const [state, setState] = useState({});

    useEffect(() => {

        Promise.resolve(null).then(currentUser => {
            if (currentUser && currentUser.attributes) {
                setState(state => {
                    state.currentUser = currentUser;
                    state.signedIn = true;
                    state.email = currentUser.attributes.email;
                    state.name = currentUser.attributes.name;
                    return state;
                })
            }
        })
    }
    );

    return (
        <View>
            <div>
                <Helmet>
                    <meta name="title"content="Best Pet Health Insurance | Pet Medical Health Cover Policy | PawtectIndia" />
                    <meta name="description"content="Discover top Digit pet insurance plans to ensure your pets get the best medical health cover when they need it. PawtectIndia offers best pet health insurance with comprehensive policies." />
                    <meta name="keywords" content="pet insurance, pet medical cover, pet health cover, pet health policy, pet health insurance" />
                    <meta property="og:title" content="Best Pet Health Insurance | Pet Medical Health Cover Policy | PawtectIndia" />
                    <meta property="og:type" content="website" />
                    <meta property="og:url" content="https://www.pawtectindia.com/" />
                    <meta property="og:image" content="https://www.pawtectindia.com/img/img-pawtect-plan.png" />
                    <meta property="og:site_name" content="welcogm" />
                    <meta property="og:description" content="Discover top Digit pet insurance plans to ensure your pets get the best medical health cover when they need it. PawtectIndia offers best pet health insurance with comprehensive policies." />
                    <meta name="twitter:card" content="summary_large_image" />
                    <meta name="twitter:site" content="@pawtect_india" />
                    <meta name="twitter:title" content="Best Pet Health Insurance | Pet Medical Health Cover Policy | PawtectIndia" />
                    <meta name="twitter:description" content="Discover top Digit pet insurance plans to ensure your pets get the best medical health cover when they need it. PawtectIndia offers best pet health insurance with comprehensive policies." />
                    <meta name="twitter:image" content="https://www.pawtectindia.com/img/img-pawtect-plan.png" />
                </Helmet>
            </div>
            <Card paddingTop={'20px'} paddingBottom={'5px'}>
                {/*/HEADER*/}
                <Grid
                    templateColumns={{ base: '1fr auto', medium: '2fr 6fr 1fr' }}
                    columnGap={'10px'}
                    rowGap={'10px'}
                    alignItems={'center'}
                    padding={'0px'}
                >
                    <div style={{ justifySelf: 'start', display: 'flex', alignItems: 'center', gap: '16px', flexWrap: 'wrap' }}>
                        <Link to="/">
                            <img src="img/vetina-LOGO-230-px.png" alt="Pawtect India" style={{ width: '100%', maxWidth: '230px', height: 'auto' }} />
                        </Link>
                        <a href="https://www.godigit.com" target="_blank" rel="noopener noreferrer" aria-label="Insured by Go Digit General Insurance">
                            <img src="img/digit.svg" alt="Insured by Go Digit General Insurance" style={{ maxWidth: '120px', height: 'auto' }} />
                        </a>
                    </div>
                    <Link to="/help" className="header-help-link" style={{ justifySelf: 'end', alignSelf: 'center' }}>
                        Help
                    </Link>
                    <button
                        type="button"
                        onClick={handleCartButton}
                        aria-label={`Open cart, ${cartCount} item${cartCount === 1 ? '' : 's'}`}
                        style={{ justifySelf: 'end', background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}
                    >
                        <Image
                            src="img/bag.png"
                            alt=""
                            width={'50px'}
                        ></Image>
                        <Badge variation={cartCount > 0 ? 'success' : 'warning'}>
                            {cartCount} <span style={{ marginLeft: '2px' }}>in cart</span>
                        </Badge>
                    </button>
                </Grid>
                <CartPreview />
            </Card>

        </View>
    );
};
export default HeaderNew;
